export class HDConfigurationModel{
     apiClientName:string;
     hdTanancyURL:string;
     servicePrincipalName:string;
     servicePrincipalSecret:string;
     servicePrincipalURL:string;
     documentAssemblyApiUrl:string;
}